import { read_cookie, create_cookie } from './utils';
import { logger } from './logger';
var ls_support = true;
var data;
try {
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('testLocal', 'true');
    }
}
catch (e) {
    ls_support = false;
}
export function store(key, _a, value) {
    var _b = (_a === void 0 ? {} : _a).storageOnly, storageOnly = _b === void 0 ? true : _b;
    var domain = '.codemao.cn';
    if (typeof value !== 'undefined' && value !== null) {
        if (window && document) {
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            if (ls_support) {
                localStorage.setItem(key, value);
            }
            else if (!storageOnly) {
                create_cookie(key, value, 30, domain);
            }
        }
        else if (wx) {
            wx.setStorageSync(key, value);
        }
        else {
            logger.error('该平台没有部署ca支持的存储接口');
        }
    }
    if (typeof value === 'undefined') {
        if (window && document) {
            if (ls_support) {
                data = localStorage.getItem(key);
            }
            else if (!storageOnly) {
                data = read_cookie(key);
            }
            try {
                data = JSON.parse(data);
            }
            catch (e) { }
            return data;
        }
        else if (wx) {
            wx.getStorageSync(key);
        }
        else {
            logger.error('该平台没有部署ca支持的存储接口');
        }
    }
    if (value === null) {
        if (window && document) {
            if (ls_support) {
                localStorage.removeItem(key);
            }
            else if (!storageOnly) {
                create_cookie(key, '', -1, domain);
            }
        }
        else if (wx) {
            wx.removeStorageSync(key);
        }
        else {
            logger.error('该平台没有部署ca支持的存储接口');
        }
    }
}
